import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {InsolesCamProfileModel} from './insolesCamProfile.model';

@Injectable()
export class InsolesCamProfileConverter extends HttpModelConverter<InsolesCamProfileModel> {

    constructor() {
        super();
    }

    protected createInstance(): InsolesCamProfileModel {
        return new InsolesCamProfileModel();
    }

    protected enrichObject(result: InsolesCamProfileModel, src: InsolesCamProfileModel) {
    }

}
